export default __webpack_public_path__ + "images/0x09fa58228bb791ea355c90da1e4783452b9bd8c3.png";